<template>
  <div>
    <h2>Categories</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div class="d-flex justify-end">
      <circle-button
          @click.native="createNewCate"/>
    </div>

    <v-simple-table class="branch-data">
      <template v-slot:default>
        <thead>
        <tr>
          <th
              v-for="header in headers"
              :key="header.id"
              class="text-center"
          >
            {{ header }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, index) in dataTable"
            :key="index"
        >
          <td>
            {{ item.name_en }}
          </td>
          <td>
            {{ item.name_th }}
          </td>
          <td>
            {{ item.active == '1' ? 'Active' : 'Inactive' }}
          </td>
          <td>
            <div class="d-flex justify-center align-center" style="gap: 24px">
              <a @click="onEdit(item.id)">
                <icon-pencil />
              </a>
              <a @click="onDelete(item.id)">
                <v-icon class="fas fa-trash" size="20" color="#2E8037"></v-icon>
              </a>
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import Paginate from "@/components/Layout/Paginate"
import Loading from "vue-loading-overlay"
import IconPencil from "../../components/Icon/icon-pencil"
import CircleButton from "@/components/Button/CircleButton"
import moment from "moment"
import Swal from "sweetalert"

export default {
  name: "SubscribeEmailTable",
  components: {
    Loading,
    Paginate,
    IconPencil,
    CircleButton
  },
  data () {
    return {
      moment,
      isLoading: false,
      headers: [
          "Category (EN)",
          "Category (TH)",
          "Status",
          "Actions"
      ],
      dataTable: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onEdit (id) {
      this.$router.push({ name: "EnewsletterCategoriesEdit", params: { id } })
    },
    async onDelete (id) {
      let isConfirm = await Swal({
        title: "Confirm to delete category?",
        icon: "warning",
        buttons: ['Cancel', 'Confirm']
      })
      if (isConfirm) {
        await this.$store.dispatch('SupportContact/deleteEnewsletterCategoryById', id)
        this.getTables()
      }
    },
    createNewCate () {
      this.$router.push({ name: "EnewsletterCategoriesEdit" })
    },
    async getTables () {
      this.isLoading = true
      let res = await this.$store.dispatch('SupportContact/getEnewsletterCategories')
      if (res && res.result) {
        this.dataTable = res.result
      }
      this.isLoading = false
    }
  }
}
</script>

<style scoped>

</style>